(function (w, $) {
    const assetId = '~/Parts/Views/Site/PriceVATModeSelector.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    let cookie = $.cookie;
    if (!cookie && window.cms && window.cms.cookie) {
        cookie = window.cms.cookie;
    }

    for (let ctx of w.umwAssets[assetId]) {
        const $mainContainer = $('#' + ctx.containerId);
        $mainContainer.find('.js-price-vat-mode-selector').change(function() {
            cookie(ctx.cookieName,
                this.checked ? 'True' : 'False',
                { expires: 365, path: w.R });
            reloadPageAsGet();
        });
    }

    function reloadPageAsGet() {
        const loc = window.location;
        window.location = loc.protocol + '//' + loc.host + loc.pathname + loc.search;
    }
})(window, jQuery);